import React from 'react';

export const styles = {
  modalTitle: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontSize: '18px',
    fontWeight: '600',
  },
  modalContent: {
    textAlign: 'center',
    padding: '20px 0',
  },
  iconContainer: {
    marginBottom: '16px',
  },
  description: {
    margin: '0 0 16px 0',
    color: '#666',
    fontSize: '14px',
  },
  instruction: {
    margin: '0',
    fontSize: '14px',
  },
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '12px',
  },
  spinnerText: {
    fontSize: '14px',
  },
  modalFooter: {
    textAlign: 'center',
  },
};

export const createModalTitle = title =>
  React.createElement('div', { style: styles.modalTitle }, title);
